import React from "react";
import { ErrorMessage } from "formik";

const CustomError = ({ name }) => {
  return <ErrorMessage name={name} component="div" className="text-danger" />;
};

export default CustomError;
